<template>
    <div>
        <section class="quiz-header">
            <div class="left-quiz">
                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/quiz/quiz-l.png"/>
            </div>
            <div class="right-quiz">
                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/quiz/quiz-r.png"/>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2 col-sm-8 col-sm-offset-2">
                        <div class="quiz-header-heading">
                            <img :src="quizData.sharing_image ? quizData.sharing_image : '/images/quiz-default.png'"/>
                            <p>{{ quizData.name }}</p>
                            <p class="quiz-detail-cat">{{ quizData.category }} </p>
                            <div class="quiz-timings-cover">
                                <div class="reg-deadline" v-if="quizData.registration_end_datetime"><i class="fas fa-user-clock"></i> Registration Deadline : <span> {{ getFullDate(quizData.registration_end_datetime) + ' ' +getTime(quizData.registration_end_datetime)}}</span></div>
                                <div class="both-btns">
                                    <div class="register-detail-btn-2" v-if="quizData.is_played == true">
                                        <a href="javascript:;">Already Played</a>
                                    </div>
                                    <div class="register-detail-btn-2" v-else-if="quizData.quiz_enc_id && userType === 'Individual' && quizData.is_expired == 'false'">
                                        <a v-if="!is_registered && quizData.reg_expired == 'false'" href="javascript:;" @click="registerWebinar($event)" :data-key="quizData.quiz_enc_id">Register Now</a>
                                        <router-link v-else-if="is_started && is_registered" :to="{path: '/dashboard/play/' + quizData.slug}">Play Quiz</router-link>
                                        <a v-else-if="is_registered && !is_started" href="javascript:;">Registered</a>
                                        <a v-else-if="!is_registered && quizData.reg_expired == 'true'" href="javascript:;">Registration Closed</a>
                                    </div>
                                    <div class="register-detail-btn-2" v-else-if="!userType && quizData.is_expired == 'false' && quizData.reg_expired == 'false'">
                                        <a href="javascript:;" @click="openLogin()">Register Now</a>
                                    </div>
                                    <div class="register-detail-btn-2" v-else-if="quizData.is_expired == 'true'">
                                        <a href="javascript:;">Expired</a>
                                    </div>
<!--                                    <div class="register-detail-btn-2" v-else-if="quizData.reg_expired == 'true'">-->
<!--                                        <a href="javascript:;">Registration Closed</a>-->
<!--                                    </div>-->
<!--                                    <div class="addeventatc" title="Add To Calendar" id="addeventatc1" aria-haspopup="true" aria-expanded="false" tabindex="0" translate="no" data-loaded="true" style="visibility: visible; z-index: 100000;">-->
<!--                                        <span class="start atc_node notranslate">2021-11-11 06:15:26</span>-->
<!--                                        <span class="end atc_node notranslate">2021-11-11 06:15:26</span>-->
<!--                                        <span class="timezone atc_node notranslate">Asia/Kolkata</span>-->
<!--                                        <span class="title atc_node notranslate">testing1 quiz test</span>-->
<!--                                        &lt;!&ndash;                            <span class="description">Description of the event</span>&ndash;&gt;-->
<!--                                        <span class="addeventatc_icon atc_node notranslate"></span><span id="addeventatc1-drop" class="addeventatc_dropdown  " aria-hidden="true" aria-labelledby="addeventatc1"><span class="ateappleical" id="addeventatc1-appleical" role="menuitem" tabindex="-1">Apple</span><span class="ategoogle" id="addeventatc1-google" role="menuitem" tabindex="-1">Google <em>(online)</em></span><span class="ateoffice365" id="addeventatc1-office365" role="menuitem" tabindex="-1">Office 365 <em>(online)</em></span><span class="ateoutlook" id="addeventatc1-outlook" role="menuitem" tabindex="-1">Outlook</span><span class="ateoutlookcom" id="addeventatc1-outlookcom" role="menuitem" tabindex="-1">Outlook.com <em>(online)</em></span><span class="ateyahoo" id="addeventatc1-yahoo" role="menuitem" tabindex="-1">Yahoo <em>(online)</em></span><em class="copyx"><em class="brx"></em><em class="frs"><a href="https://www.addevent.com" title="" tabindex="-1" id="addeventatc1-home">AddEvent.com</a></em></em></span></div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="quiz-detail-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <div class="detail-side">
                            <h3 class="quiz-title">{{ quizData.name }}</h3>
                            <p class="quiz-detail-cat">{{ quizData.category }}</p>
                            <div class="quiz-description" v-html="quizData.description">

                            </div>
                        </div>
                        <div class="register-count">
                            <div class="registered-c">
                                <div class="avatars">
                                    <ul class="ask-people" v-if="quizData.quiz_enc_id && quizData.registered_users.length > 0">
                                        <li v-for="ru in quizData.registered_users">
                                            <img :src="ru.image"/>
                                        </li>
                                    </ul>
                                    <p><span>{{quizData.registered_count}}</span> People Registered</p>
                                </div>
                            </div>
                            <div class="viewers"></div>
                        </div>
                        <div class="share-social-links">
                            <a href="javascript:;" class="fb"
                               onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-facebook-f"></i></a>
                            <a href="javascript:;" class="wts-app"
                               onclick="window.open('https://api.whatsapp.com/send?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-whatsapp"></i></a>
                            <a href="javascript:;" class="tw"
                               onclick="window.open('https://twitter.com/intent/tweet?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-twitter"></i></a>
                            <a :href="'mailto:https://myecampus.in'+this.$route.fullPath" class="male">
                                <i class="far fa-envelope"></i></a>
                            <a href="javascript:;" class="fb"
                               onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&amp;url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-linkedin"></i></a>
                            <a href="javascript:;" class="male"
                               onclick="window.open('http://pinterest.com/pin/create/link/?url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-pinterest"></i></a>
                            <a href="javascript:;" class="tw"
                               onclick="window.open('https://telegram.me/share/url?url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-telegram"></i></a>
                        </div>
                    </div>
                    <div class="col-md-4 margin-top-20">
                        <div class="row">
<!--                            <div class="col-md-12">-->
<!--                                <div class="register-detail-btn" v-if="quizData.quiz_enc_id && userType === 'Individual'">-->
<!--                                    <a v-if="!is_registered" href="javascript:;" @click="registerWebinar($event)" :data-key="quizData.quiz_enc_id">Register Now</a>-->
<!--                                    <a href="javascript:;" v-else>Registered</a>-->
<!--                                </div>-->
<!--                                <div class="register-detail-btn" v-if="!userType">-->
<!--                                    <a href="javascript:;" @click="openLogin()">Register Now</a>-->
<!--                                </div>-->
<!--                            </div>-->
                            <div class="col-md-12" v-if="quizData.quiz_enc_id">
                                <div class="countdown clearfix" v-if="!is_started">
    <!--                                <div class="countdown clearfix">-->
                                        <h4>Starts In:</h4>
                                    <div class="counter-item">
                                        <span class="days">{{ days }}</span>
                                        <div class="smalltext">Days</div>
                                        <b>:</b>
                                    </div>
                                    <div class="counter-item">
                                        <span class="hours">{{ hours }}</span>
                                        <div class="smalltext">Hours</div>
                                        <b>:</b>
                                    </div>
                                    <div class="counter-item">
                                        <span class="minutes">{{ minutes }}</span>
                                        <div class="smalltext">Minutes</div>
                                        <b>:</b>
                                    </div>
                                    <div class="counter-item">
                                        <span class="seconds">{{ seconds }}</span>
                                        <div class="smalltext">Seconds</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="nd-shadow timings-cover">
                                    <div class="register-dead block-span" v-if="quizData.registration_end_datetime"><i class="fas fa-user-clock"></i> <span>Registration Deadline : <strong> {{ getFullDate(quizData.registration_end_datetime) + ' ' +getTime(quizData.registration_end_datetime)}} IST</strong></span></div>
                                    <div class="register-fee block-span"><i class="fas fa-rupee-sign"></i> <span>Registration Fee : <strong v-if="quizData.is_paid == '1'">{{quizData.currency_html_code + quizData.price}}</strong><strong v-else>Free</strong></span></div>
                                    <div class="play-time block-span" v-if="quizData.quiz_start_datetime"><i class="far fa-play-circle"></i> <span>Quiz Start Time : <strong>{{ getFullDate(quizData.quiz_start_datetime) + ' ' +getTime(quizData.quiz_start_datetime)}}</strong></span></div>
                                    <div class="play-time block-span" v-if="quizData.quiz_end_datetime"><i class="far fa-play-circle"></i> <span>Quiz End Time : <strong>{{ getFullDate(quizData.quiz_end_datetime) + ' ' +getTime(quizData.quiz_end_datetime)}}</strong></span></div>
                                    <div class="total-question block-span" v-if="quizData.num_of_ques"><i class="fas fa-print"></i> <span>Total Questions : <strong>{{ quizData.num_of_ques }}</strong></span></div>
                                    <div class="total-time block-span" v-if="quizData.duration"><i class="fas fa-clock"></i> <span>Total Time : <strong>{{ quizData.duration }} minutes</strong></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="sponsorBg" v-if="quizData.quiz_enc_id && quizData.quizSponsors.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="sponsorsFlex">
                            <h2>Quiz <br> Sponsors</h2>
                            <div class="sponsor-box-flex">
                                <div class="sponsorBox" v-for="sl in quizData.quizSponsors">
                                    <router-link :to="{path: '/profile?slug=' + sl.organizationEnc.slug}">
                                        <img :src="sl.organizationEnc.logo"/>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="rewards-section" v-if="quizData.name && quizData.quizRewards.length">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="heading-style">Rewards & Prizes</div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-6" v-for="qd in quizData.quizRewards">
                        <div class="rewards-win nd-shadow">
                            <div class="certificate-set" v-if="qd.quizRewardCertificates.length">Certificate</div>
                            <div class="reward-img">
                                <img src="https://empoweryouth.com/assets/themes/ey/images/pages/quiz/prize100.png"/>
                            </div>
                            <h3>{{ qd.position_name }}</h3>
                            <p v-if="qd.price">Rs {{qd.price}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="related-quiz-section"  v-if="related_quiz.length">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="heading-style">Related Quizzes</div>
                    </div>
                    <div class="col-md-4" v-for="data in related_quiz">
                        <router-link :to="{path: '/quiz/' + data.slug}">
                            <router-link :to="{path: '/quiz/detail/' + data.slug}">
                                <div class="card-main nd-shadow">
                                    <div class="paid-webinar" v-if="data.is_paid == '1'">Paid</div>
                                    <div class="expired-btn" v-if="data.is_expired == 'true'">EXPIRED</div>
                                    <div class="card-img">
                                        <img :src="data.sharing_image ? data.sharing_image : '/images/quiz-default.png'"/>
                                    </div>
                                    <div class="card-details">
                                        <div class="about-first flex-container">
                                            <div class="register-date" style="flex-grow: 1"><i
                                                class="far fa-user"></i> {{ data.registered_count }} Registered
                                            </div>
                                            <div class="pricing-money" style="flex-grow: 8" v-if="data.quizRewards.length">
                                                <img src="https://shshank.eygb.me/assets/themes/ey/images/pages/quiz/PRIZE.png">
                                                ₹{{ data.quizRewards[0].price }}
                                            </div>
                                        </div>
                                        <div class="about-name">
                                            <div class="quiz-name">{{ data.name }}</div>
                                            <div class="quiz-category">{{data.category}}</div>
                                        </div>
                                        <div class="about-footer">
                                            <div class="views-count">
                                                <!--                                                    <i class="fa fa-eye"></i> 6 Views-->
                                            </div>

                                            <div class="register-date" v-if="data.price">
                                                <i class="fas fa-rupee-sign"></i>{{ data.price }}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </router-link>
                        </router-link>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import toastr from "../../public/js/toastr";
import {paymentAccessToken} from "../_helpers/apiRoute.js";
import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";

export default {
    components: {

    },
    data() {
        return {
            quizData: {},
            related_quiz: [],
            userType: this.$store.getters.getUserType,
            is_registered:false,
            is_started:false,
            days: "",
            hours: "",
            minutes: "",
            seconds: "",
        }
    },
    mounted() {
        if (window.location.pathname.split("/").length > 4 || window.location.pathname.split("/").length < 3) {
            alert("Invalid Url");
            this.$router.push({path: '/'});
            return false;
        }
        this.getQuizDetail();
    },
    methods: {
        getQuizDetail() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/quiz/detail`, {slug: window.location.pathname.split("/").slice(-1).toString()}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.quizData = response['data']['response']['detail'];
                    t.related_quiz = response['data']['response']['related'];
                    t.is_registered = response['data']['response']['detail'].is_registered;
                    t.countdown(response['data']['response']['detail'].quiz_start_datetime);
                } else if (response['data']['response']['status'] == 404) {
                    alert('Quiz Not Found!');
                    t.$router.go(-1);
                } else {
                    alert('Unstable internet connection or an error occurred!');
                    window.location.replace("/");
                }
            });
        },
        registerWebinar(e) {
            var element = e.currentTarget;
            element.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i>';
            var data_key = element.getAttribute('data-key');
            var t = this;
            var url = this.$store.getters.getDomain;
            axios.post(`${url}api/v2/quiz/register`, {quiz_id: data_key}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 201) {
                    element.textContent = 'Registered';
                    element.disabled = true;
                    element.classList = "ra-btn ra-actions disabled";
                    t.is_registered = true;

                } else if (response['data']['response']['status'] == 200) {
                    t.paymentPage(response['data']['response']['data'].payment_token, response['data']['response']['data'].payment_enc_id, response['data']['response']['data'].registration_enc_id)
                }
            });
        },
        paymentPage(paymentId, paymentEncId, registrationEncId) {
            var t = this;
            var options = {
                "key": paymentAccessToken(), // Enter the Key ID generated from the Dashboard
                "name": "My E-Campus",
                "description": "Quiz Registration Fees",
                "image": "https://www.myecampus.in/images/e_campus_logo.png",
                "modal": {
                    "ondismiss": function () {
                        t.updateApplication('','', paymentEncId, registrationEncId,'cancelled');
                    }
                },
                "order_id": paymentId,
                "handler": function (response){
                    t.updateApplication(response.razorpay_payment_id,response.razorpay_signature, paymentEncId, registrationEncId,'captured');
                },
            };
            var rzp1 = new Razorpay(options);
            rzp1.open();
            rzp1.on('payment.failed', function (response){
                t.updateApplication('','', paymentEncId, registrationEncId,'failed');
            });
            // Layer.checkout({
            //         token: paymentId,
            //         accesskey: paymentAccessToken(),
            //     },
            //     function (response) {
            //         t.updateApplication(response, paymentEncId, registrationEncId);
            //         if (response.status == "captured") {
            //             // response.payment_token_id
            //             // response.payment_id
            //         } else if (response.status == "created") {
            //         } else if (response.status == "pending") {
            //         } else if (response.status == "failed") {
            //
            //         } else if (response.status == "cancelled") {
            //         }
            //     },
            //     function (err) {
            //         console.log(err)
            //         //integration errors
            //     }
            // );
        },
        openLogin(){
            this.$parent.openLoginModal()
        },
        updateApplication(paymentId,paymentSignature, paymentEncId, registrationEncId,status) {
            var t = this;
            showLoader()
            var url = this.$store.getters.getDomain;
            var res = {};
            // res['loan_app_id'] = loanAppId;
            // res['loan_payment_id'] = eduLoanId;
            res['payment_id'] = paymentId;
            res['signature'] = paymentSignature;
            res['status'] = status;
            res['payment_enc_id'] = paymentEncId;
            // res['registration_enc_id'] = registrationEncId;
            // res['payment_enc_id'] = paymentEncId;
            // res['registration_enc_id'] = registrationEncId;
            axios.post(`${url}api/v2/quiz/update-payment-status`, res, {
                headers: requestHeaders()
            }).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    toastr.success('Quiz Registration Fees ' + res.status, 'Success');
                    location.reload();
                    // t.$router.push({path: '/dashboard'});
                }
                hideLoader()
            })
                .catch(function (error) {
                    // t.getFeeComponents();
                })
        },
        getFullDate(e) {
            var d = new Date(e);
            var months = ["January", "February", "March", "April", "May", "June", "July", "August", "Sep", "Oct", "November", "December"];
            return d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear();
        },
        getTime(e) {
            var date = new Date(e);
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            minutes = minutes < 10 ? '0'+minutes : minutes;
            var strTime = hours + ':' + minutes + ' ' + ampm;
            return strTime;
        },
        countdown(e) {
            var t = this;
            var countDownDate = new Date(e).getTime();

            var x = setInterval(function () {

                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                t.days = Math.floor(distance / (1000 * 60 * 60 * 24));
                t.hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                t.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                t.seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // Output the result in an element with id="demo"
                // document.getElementById("demo").innerHTML = days + "d " + hours + "h "
                //     + minutes + "m " + seconds + "s ";

                // If the count down is over, write some text
                if (distance < 0) {
                    clearInterval(x);
                    t.is_started = true;
                }
            }, 1000);
        },
    }
}
</script>

<style scoped>
.addeventatc{
    height:32px;
    width:34px;
    padding:0 !important;
    margin-left:6px;
}
.addeventatc .addeventatc_icon {
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
}
.nd-shadow {
    box-shadow: 0px 1px 10px 2px #eee !important;
}
.quiz-header {
    min-height: 500px;
    position: relative;
    background: linear-gradient(hsla(0,0%,100%,0),rgb(120 198 254 / 44%));
}
.left-quiz {
    position: absolute;
    left: 0;
    top: 0;
}
.right-quiz {
    position: absolute;
    right: 0;
    bottom: 0;
}
.quiz-header-heading p {
    font-size: 20px;
    font-family: "Roboto";
    color: #00a0e3;
    margin:0;
}
.quiz-header-heading img {
    width: 100px;
    height: 100px;
    object-fit: fill;
    border: 2px solid #afddff;
    padding: 2px;
    border-radius: 4px;
    margin-bottom:20px;
}
.quiz-header-heading {
    text-align: center;
    margin-top: 100px;
    padding-top: 80px;
}
.quiz-timings-cover {
    display: flex;
    align-items: center;
    border: 2px solid #00a0e3;
    border-radius: 4px;
    flex-wrap: wrap;
    justify-content: center;
    background: #00a0e3;
    padding: 8px 0;
    margin:15px 0;
}
.reg-deadline, .days-left2 {
    border-right: 2px solid #fff;
    padding-right: 15px;
    margin-right: 15px;
    font-family: "Roboto";
    color: #fff;
}
.reg-deadline i, .days-left2 i {
    color: #fbba00;
    margin-right:2px;
}
.register-detail-btn-2 a{
    display:block;
    text-align: center;
    font-family:"roboto";
    font-weight:500;
    font-size: 15px;
    width: 150px;
    border-radius: 4px;
    margin: 0;
    background-color: #fff;
    color: #00a0e3;
    padding: 8px 0;
}
.both-btns {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.quiz-title {
    font-family: lora;
    font-weight: 600;
    font-size: 28px;
    margin-bottom: 0;
    color: #00a0e3;
    line-height: 30px;
}
.quiz-detail-cat {
    font-family: "Roboto";
    color: #fbba00 !important;
    text-transform: capitalize;
    font-size: 16px !important;
}
.quiz-description {
    font-family: "Roboto";
    text-align: justify;
    line-height: 25px;
    font-size: 15px;
}
.register-detail-btn a {
    display: block;
    background-color: #00a0e3;
    color: #fff;
    width: 100%;
    text-align: center;
    padding: 8px;
    font-family: "Roboto";
    font-weight: 500;
    margin: 20px 0;
    font-size: 17px;
    border-radius: inherit;
}
.register-detail-btn a.mt-0{
    margin-top:0px;
}
.timings-cover {
    padding: 20px;
    font-family: "Roboto";
    margin-bottom:20px;
}
.block-span {
    margin-bottom: 10px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
}
.block-span span {
    display: block;
    padding-left: 10px;
}
.block-span span strong{
    display:block;
    font-weight:500;
    margin-top:2px;
}
.block-span i {
    font-size: 20px;
    color: #00a0e3;
    margin-right: 5px;
    width: 22px;
    text-align: center;
}
.block-span:last-child {
    margin: 0;
    border-bottom: 0;
    padding:0;
}
.reward-heading {
    /*text-shadow: 0px 2px 2px black, 0px 0px 8px white;*/
    font-family: lora;
    font-size: 32px;
    margin: 0 0 15px 0;
    font-weight: 600;
}
.rewards-win {
    padding: 20px;
    margin-bottom: 15px;
    text-align: center;
    position: relative;
    overflow: hidden;
}
.certificate-set {
    position: absolute;
    left: -23px;
    top: 16px;
    background-color: #00a0e3;
    color: #fff;
    font-family: "Roboto";
    padding: 1px 22px;
    transform: rotate(-45deg);
    font-size: 12px;
}
.reward-img img {
    width: 60px;
}
.rewards-win h3 {
    font-size: 16px;
    font-family: "Roboto";
    font-weight: 500;
    margin-bottom:0;
    color:#00a0e3;
}
.rewards-win p {
    font-family: "roboto";
    font-weight: 500;
    color: #949494;
    font-size: 16px;
    margin-bottom:0;
}
.avatars {
    display: flex;
    align-items: center;
    margin-left: -20px;
    margin-bottom: 30px;
}
.avatars p {
    font-size: 18px;
    padding-top: 10px;
    margin-left: 40px;
    margin-bottom: 0px;
}
.ask-people{
    margin-top: 10px;
    margin-left: 20px;
}
.sidebar h5{
    font-size: 16px;
}
.ask-people li{
    width: 50px;
    height: 50px;
    border: 2px solid #fff;
    border-radius: 50%;
    display: inline-block;
    margin-right: -28px;
}
.ask-people li img{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}
/* card css starts here */
.card-main {
    border-radius: 4px;
    overflow: hidden;
    margin-bottom:30px;
    position:relative;
}
.paid-webinar {
    position: absolute;
    right: -25px;
    background-color: #f80000;
    color: #fff;
    font-family: "Roboto";
    font-weight: 700;
    padding: 0px 28px;
    transform: rotate(45deg);
    top: 14px;
    letter-spacing: 2px;
    text-transform: uppercase;
}

.card-img img {
    width: 100%;
    height: 210px;
    object-fit: fill;
    border-radius:4px 0 0 0;
}
.card-details {
    padding: 10px;
    font-family: "Roboto";
}
.flex-container {
    display: flex;
    align-items: center;
    margin: 10px 0;
}
.days-left i, .register-date i {
    color: #00a0e3;
    font-size: 16px;
    margin-right: 2px;
}
.pricing-money {
    text-align: right;
    font-size: 16px;
    color: #e2bc0c;
}
.pricing-money i {
    font-size: 24px;
}
.quiz-name {
    font-size: 18px;
    font-family: "Roboto";
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.quiz-category {
    text-transform: capitalize;
    color: #b8b8b8;
    margin-bottom:10px;
}
.about-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.view-details2 {
    background: linear-gradient(346deg, rgb(189 234 255) 0%, rgba(23,148,190,1) 47%);
    color: #fff !important;
    padding: 4px 18px;
    display: inline-block;
    border-radius: 32px;
    margin-right:5px;
}
.view-details2:focus, .view-details2:hover{
    color:#fff;
    transform: scale(1.05);
    transition: all .3s;
}
.expired-btn {
    padding: 0px 10px;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    font-family: "Roboto";
    font-weight:500;
}
.views-count {
    color: #018e01;
}
/* card css ends here */
@media screen and (max-width: 1200px) {
    .reg-deadline, .days-left2{
        border: none;
        margin-bottom: 5px;
    }
    .quiz-timings-cover{
        flex-direction:column;
    }
    register-detail-btn-2{
        margin-bottom:5px;
    }
}
@media screen and (max-width: 992px) {
    .quiz-header .left-quiz img, .quiz-header .right-quiz img {
        width: 150px;
    }
}
@media screen and (max-width: 767px) {
    .quiz-header .left-quiz img, .quiz-header .right-quiz img {
        width: 85px;
    }
    .basis {
        flex-basis: 49%;
    }
}
.share-social-links {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
}

.share-social-links > a {
    min-width: 90px;
    margin: 15px 1% 0 0;
}

.share-social-links > a:last-child {
    margin-right: 0;
}

.wts-app {
    background-color: #25D366;
}

.male {
    background-color: #d3252b;
}

.tw {
    background-color: #1c99e9;
}

.fb {
    background-color: #236dce;
}

.wts-app i, .male i, .tw i, .fb i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: 10px 0;
}

.share-social-links:hover a {
    opacity: 0.6;
}

.share-social-links > a:hover {
    opacity: 1;
}

/*{*/
/*    padding: 0;*/
/*    margin: 0;*/
/*    z-index: 1;*/
/*    position: relative;*/
/*}*/
.gradient {
    background-image: linear-gradient(144deg, #00C0FF 0%, #236CD7 51%, #4218B8 100%);
    width: 100%;
    height: 100%;
    position: relative;
}

.countdown {
    margin-bottom: 20px;
    box-shadow: 0px 1px 10px 0px #ddd;
}
.countdown > h4 {
    text-align: center;
    color: #00a0e3;
    margin-top: 15px !important;
}

.countdown .counter-item {
    width: 25%;
    float: left;
    margin-right: 0;
    border: none;
    position: relative;
    height: auto;
}

.countdown .counter-item {
    width: 25%;
    float: left;
    margin-right: 0;
    border: none;
    position: relative;
    height: auto;
}

.countdown .counter-item {
    display: inline-block;
    width:calc(100%/4);
    height: 80px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -ms-border-radius: 50%;
    text-align: center;
    color: #222;
    margin-right: 0px;
    padding: 25px 0;
    padding-top:10px;
    position: relative;
}

.countdown .counter-item {
    text-align: center;
    color: #222;
    font-size: 25px;
}

.countdown .counter-item .smalltext {
    font-size: 9px;
    text-transform: uppercase;
    letter-spacing: 2.5px;
    margin-top:5px;
}

.countdown .counter-item b {
    position: absolute;
    right: 0;
    top: 44%;
    bottom: 0;
    margin: auto;
    font-size: 25px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
.sponsorBg{
    margin-top: 30px;
    background: #5ac1ec;
    padding: 30px 0px;
}
.sponsorBg .container{
    padding: 20px !important;
}
.sponsorsFlex{
    display: flex;
    align-items: center;
}
.sponsor-box-flex{
    flex-basis: 80%;
    display: flex;
    flex-wrap: wrap;
}
.sponsorsFlex h2{
    color: #fff;
    flex-basis: 20%;
    line-height: 45px;
    font-size: 38px;
    font-family: lora;
    padding: 0 0 0 10px;
    border-left: 5px solid #ff7803;
}
.sponsorBox{
    max-width: 30%;
    height: 150px;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    box-shadow: 5px 5px 12px 0 rgb(0 0 0 / 20%);
    margin: 10px 15px;
    position: relative;
}
.sponsorBox img,
.sponsorBox canvas{
    width: 100%;
    max-width: 100%;
    height: 100%;
    object-fit: contain;
    padding: 20px;
    transform: translatey(0px);
}

.sponsorBox a canvas{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
}
</style>